import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import * as InsOutsReport from 'reports/components/ins_outs';
import * as Common from 'common/components';

class InsOutsReportView extends Component {
  static propTypes = {
    company: PropTypes.object.isRequired,
    subcompany: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    children: PropTypes.arrayOf(PropTypes.element),
    filters: PropTypes.shape({
      fulltext: PropTypes.string.isRequired,
    }).isRequired,
    pagination: PropTypes.shape({
      page: PropTypes.number.isRequired,
      limit: PropTypes.number.isRequired,
      totalPages: PropTypes.number.isRequired,
      orderBy: PropTypes.string.isRequired,
      order: PropTypes.string.isRequired,
    }).isRequired,
    isLoading: PropTypes.bool.isRequired,
    handleToggleSearch: PropTypes.func.isRequired,
    handleExactSearch: PropTypes.func.isRequired,
    columnSearch: PropTypes.array.isRequired,
    handleFiltersChange: PropTypes.func.isRequired,
    handleFiltersSubmit: PropTypes.func.isRequired,
    handleLimitChange: PropTypes.func.isRequired,
    handleOrderChange: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  render = () => (
    <Common.Wrapper fluid={true}>
      <InsOutsReport.Header
        companyId={this.props.company.id}
        subcompanyId={this.props.subcompany.id}
        handleExport={this.props.handleExport}
        handleExportPDF={this.props.handleExportPDF}
      />
      <div className="col-12">
        <Common.Portlet title={this.props.t('reports.ins_outs.subtitle')} icon={'file-archive-o'}>
          <InsOutsReport.Filters
            handleToggleSearch={this.props.handleToggleSearch}
            handleExactSearch={this.props.handleExactSearch}
            columnSearch={this.props.columnSearch}
            accounts={this.props.accounts}
            employees={this.props.employees}
            costCenters={this.props.costCenters}
            status={this.props.status}
            values={this.props.filters}
            handleValueChange={this.props.handleFiltersChange}
            handleSubmit={this.props.handleFiltersSubmit}
          />
          <div className="mb-2" style={{ position: 'relative' }}>
            <InsOutsReport.Table
              company={this.props.company}
              subcompany={this.props.subcompany}
              permissions={this.props.permissions}
              count={this.props.count}
              orderBy={this.props.pagination.orderBy}
              order={this.props.pagination.order}
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.children}
            </InsOutsReport.Table>
            <Common.LoaderOverlay show={this.props.isLoading} />
          </div>
          <Common.Pagination
            {...this.props.pagination}
            customLimits={[25, 50, 100, 500]}
            handleLimitChange={this.props.handleLimitChange}
            handlePageChange={this.props.handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
}

export default translate()(InsOutsReportView);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/InsOutsReportView.js